// Angular uses name-with-dashes for attribute names and camelCase for the corresponding directive name)

app.directive('keyboardWatcher',
    ['$document', '$timeout', '$interval', function ($document, $timeout, $interval) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs, controller, transcludeFn) {
                var waitForResizeTimer = null;
                var viewportHeight = 0;
                var viewportWidth = 0;
                var viewPortFullHeight = window.innerHeight;

                function hideKeyboard() {
                    var elm = element[0];
                    if (elm && ((/^(input|textarea|select)$/i).test(elm.tagName) || elm.isContentEditable)) {
                        elm.blur && elm.blur();
                        document.querySelector('ion-content').style.height = 'unset'
                    }
                }

                function stopTimer(timer) {
                    if (timer) {
                        $interval.cancel(timer);
                        waitForResizeTimer = null;
                        console.log('stop timer')
                    }
                }

                if (ionic.Platform.isAndroid()) {
                    element.on('focusin', function (event) {
                        $timeout(function () {
                            viewportHeight = window.innerHeight;
                            viewportWidth = window.innerWidth;
                            if (!waitForResizeTimer) {
                                waitForResizeTimer = $interval(function() {
                                    console.log('full height', viewPortFullHeight, 'height', viewportHeight)
                                    if (window.innerHeight === viewPortFullHeight && window.innerWidth === viewportWidth) {
                                        stopTimer(waitForResizeTimer);
                                        hideKeyboard()
                                    }
                                }, 100, 0, false);
                            }
                        }, 650);
                    });

                    element.on('focusout', function () {
                        stopTimer(waitForResizeTimer);
                        hideKeyboard()
                    });

                    element.on('$destroy', function () {
                        stopTimer(waitForResizeTimer);
                        hideKeyboard()
                    });
                }

            }
        };
    }]);
